document.addEventListener('DOMContentLoaded', function () {

    const contactSlider = new Swiper(".banner__slider", {
        slidesPerView: 1,
        scrollbar: {
            el: ".swiper-scrollbar",
        }
    })

    const subproductsSlider = new Swiper(".subproducts-wrapper", {
        slidesPerView: 2.2,
        breakpoints: {
            640: {
                slidesPerView: 2.2,
            },
            1024: {
                slidesPerView: 3.2,
            },
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        scrollbar: {
            el: ".swiper-scrollbar",
        }
    })

    // Product Contents Slider (et-product-section)
    const productContentsSliders = document.querySelectorAll('.et-product-contents__swiper');
    productContentsSliders.forEach(function (el) {
        const sectionId = el.id.replace('et-product-contents-', '');
        const progressBar = document.getElementById('et-progress-' + sectionId);

        new Swiper(el, {
            slidesPerView: 2.5,
            spaceBetween: 8,
            freeMode: true,
            breakpoints: {
                640: {
                    slidesPerView: 3.2,
                },
                1024: {
                    slidesPerView: 4,
                },
            },
            on: {
                init: function () {
                    updateProductContentsProgress(this, progressBar);
                },
                progress: function () {
                    updateProductContentsProgress(this, progressBar);
                }
            }
        });
    });

    function updateProductContentsProgress(swiper, progressBar) {
        if (progressBar) {
            const progress = Math.max(20, Math.min(100, swiper.progress * 100));
            progressBar.style.width = progress + '%';
        }
    }

    const promoGifts = new Swiper(".promo-bundle-gifts-slider", {
        slidesPerView: 2.35,
        spaceBetween: 8,
        loop: false,
        scrollbar: {
            el: ".promo-bundle-gifts-slider .swiper-scrollbar",
        },
        navigation: {
            nextEl: ".promo-bundle-gifts-nav-btn-next",
            prevEl: ".promo-bundle-gifts-nav-btn-prev",
        },
        breakpoints: {
            600: {
                slidesPerView: "auto",
            }
        }
    })

    const coliconsslider = new Swiper(".collection__icon-slider .swiper-slider", {
        slidesPerView: "auto",
        spaceBetween: 14,
        freeMode: true
    })
    /* chatbot */
    function adjustSleakElementsPosition() {
        const stickyAddToCart = document.querySelector('.sticky-add-to-cart');
        const sleakButtonWrap = document.querySelector('#sleak-buttonwrap');
        const sleakBodyEmbed = document.querySelector('#sleak-body-embed');
        const isMobile = window.innerWidth <= 768;

        // Check if sticky-add-to-cart exists and is visible
        const stickyIsVisible =
            stickyAddToCart &&
            (stickyAddToCart.classList.contains('show') ||
                (stickyAddToCart.offsetHeight > 0 &&
                    window.getComputedStyle(stickyAddToCart).display !== 'none' &&
                    window.getComputedStyle(stickyAddToCart).visibility !== 'hidden'));

        if (stickyIsVisible) {
            // Get the height of the sticky add to cart element
            const stickyHeight = stickyAddToCart.offsetHeight;
            const stickyBottom = parseInt(window.getComputedStyle(stickyAddToCart).bottom) || 0;

            // Position sleak elements above the sticky add to cart
            const newBottom = stickyHeight + stickyBottom;

            if (sleakButtonWrap) {
                sleakButtonWrap.style.bottom = newBottom + 'px';
            }
            if (sleakBodyEmbed) {
                sleakBodyEmbed.style.bottom = newBottom + 'px';
            }
        } else {
            // Reset to default position when sticky-add-to-cart is not visible or doesn't exist
            if (sleakButtonWrap) {
                // On mobile, set bottom: 0 when sticky cart is not visible
                sleakButtonWrap.style.bottom = isMobile ? '0px' : '';
            }
            if (sleakBodyEmbed) {
                sleakBodyEmbed.style.bottom = '';
            }
        }
    }

    // Initial adjustment
    adjustSleakElementsPosition();

    // Watch for changes in the sticky-add-to-cart visibility
    const observer = new MutationObserver(adjustSleakElementsPosition);
    const stickyAddToCart = document.querySelector('.sticky-add-to-cart');

    if (stickyAddToCart) {
        observer.observe(stickyAddToCart, {
            attributes: true,
            attributeFilter: ['class', 'style'],
        });
    }

    // Also adjust on scroll and resize
    window.addEventListener('scroll', adjustSleakElementsPosition);
    window.addEventListener('resize', adjustSleakElementsPosition);
})